<template>
    <div style="position: fixed; transition: opacity 200ms ease-in-out, visibility 200ms ease-in-out; z-index: 50"
         :ref="'container'"
         :style="{'opacity': show ? 1 : 0, 'visibility': show ? 'visible' : 'hidden'}"
         :class="getCSSClass('model-manager-context-menu-container')">
        <ul :class="getCSSClass('model-manager-context-menu-list')">
            <li :class="getCSSClass('model-manager-context-menu-close-button-container')">
                <button v-html="icon('close')"
                        :class="getCSSClass('model-manager-context-menu-close-button')"
                        v-on:click="emitHide"></button>
            </li>
            <template v-for="operation in menuitems">
            <li v-if="operation.function != 'separator'"
                :style="colorIfSet(operation)"
                :class="getCSSClass('model-manager-context-menu-menuitem')"
                v-on:click="handleOperation(operation.function)"
                >
                <span v-if="icon(operation.function) != ''" v-html="icon(operation.function)" :class="getCSSClass('model-manager-context-menu-menuitem-icon')"></span>
                <span v-html="translate(operation.label)"></span>
            </li>
            <li v-else
                :class="getCSSClass('model-manager-context-menu-separator')">
                <hr>
            </li>
            </template>
        </ul>
    </div>
</template>

<script>
    export default {
        inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon'],
        props: {
            subject: {type: Object},
            show: {type: Boolean, default: false},
            cursorPosition: {type: Object, default: () => {return {x: 0, y: 0}}},
            selected: {type: Array},
            menuitems: {type: Array},
            revertXOpening: {type: Boolean, default: false}
        },
        data: function () {
            return {}
        },
        mounted() {
        },
        destroyed() {
            document.body.removeEventListener('click', this.handleClickOutside);
        },
        methods: {
            handleOperation: function(operation) {
                this.$emit('context', {operation: operation, id: this.subject.id});
                this.emitHide();
            },
            emitHide: function() {
                this.$emit('hide');
            },
            handleClickOutside: function(event) {
                event.stopImmediatePropagation();
                let inPath = false;
                if (!event.path) {
                    event.path = event.composedPath();
                }
                event.path.reverse().forEach((p) => {
                    if ((p.isSameNode) && (p.isSameNode(this.$refs['container']))) {
                        inPath = true;
                    }
                });
                if (!inPath) {
                    event.preventDefault();
                    this.emitHide();
                }
            },
            colorIfSet: function(operation) {
                if (operation.color == 'initial') {
                    return ''
                }
                return {color: operation.color}
            }
        },
        computed: {},
        watch: {
            show: function(value) {
                if (value === true) {
                    let openToX = this.cursorPosition.x + 250 > window.innerWidth ? 'right' : 'left';
                    let openToY = this.cursorPosition.y > window.innerWidth / 2 ? 'bottom' : 'top';
                    if (this.revertXOpening) {
                        openToX = openToX == 'left' ? 'right' : 'left';
                    }
                    if (openToX == 'left') {
                        this.$refs['container'].style['right'] = 'unset';
                        this.$refs['container'].style[openToX] = this.cursorPosition.x.toString() + 'px';
                    } else {
                        this.$refs['container'].style['left'] = 'unset';
                        this.$refs['container'].style[openToX] = (window.innerWidth - this.cursorPosition.x).toString() + 'px';
                    }
                    if (openToY == 'top') {
                        this.$refs['container'].style['bottom'] = 'unset';
                        this.$refs['container'].style.top = this.cursorPosition.y.toString()+'px';
                    } else {
                        this.$refs['container'].style['top'] = 'unset';
                        this.$refs['container'].style.bottom = (window.innerHeight - this.cursorPosition.y).toString()+'px';
                    }
                    document.body.addEventListener('click', this.handleClickOutside);
                    this.$nextTick(() => {
                        let bcr = this.$refs['container'].getBoundingClientRect();
                        if (bcr.top + bcr.height > window.innerHeight) {
                            let h = (window.innerHeight - bcr.height - 20);
                            if (h < 0) {
                                h = 0;
                            }
                            this.$refs['container'].style.top = h.toString()+'px';
                        }
                    })
                } else {
                    document.body.removeEventListener('click', this.handleClickOutside);
                }
            }
        }

    }
</script>
